export const RegisterResearchCrubs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Pratiche',
    path: '/pratiche',
  },
  {
    name: 'Ricerca Registro',
    path: '/pratiche/ricerca-registro',
  },
];

export const RegisterNewCrubs = [
  ...RegisterResearchCrubs,
  {
    name: 'Nuovo Registro',
    path: '/pratiche/ricerca-registro/nuovo',
  },
];

export const RegisterEditCrubs = [
  ...RegisterResearchCrubs,
  {
    name: 'Modifica Registro',
    path: '/pratiche/ricerca-registro/modifica',
  },
];

export const RegisterDetailCrubs = [
  ...RegisterResearchCrubs,
  {
    name: 'Dettaglio Registro',
    path: '/pratiche/ricerca-registro/dettaglio',
  },
];
